import { CaretDownOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import { useCallback, useMemo, useState } from 'react';

import { useNewUserAccessRights, useContentWidth } from '@app/hooks';

import { DataMigrationModal } from '@pages/DataMigration/components/DataMigrationModal';

import type { MenuProps } from 'antd';
import type { FC } from 'react';

import '@pages/DataMigration/styles/DataMigrationHeader.scss';

export const DataMigrationHeader: FC = () => {
  const { contentWidth } = useContentWidth();
  const [isModal, setModal] = useState(false);

  const {
    userAccessRights: { DataMigrations },
  } = useNewUserAccessRights();

  const hasUserRightToCreateDataMigration = useMemo(
    () => DataMigrations?.IsCreate,
    [DataMigrations]
  );

  const handleOpenModal = useCallback(() => setModal(true), []);

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={handleOpenModal} data-testid="migration-company-name">
          YClients
        </div>
      ),
    },
  ];

  if (!hasUserRightToCreateDataMigration) {
    return null;
  }

  return (
    <div className="DataMigrationHeader">
      {contentWidth > 490 ? (
        <Dropdown menu={{ items }} placement="bottomRight">
          <Button>
            <Space>
              <span data-testid="add-migration">Добавить миграцию</span>
              <CaretDownOutlined />
            </Space>
          </Button>
        </Dropdown>
      ) : (
        <Dropdown menu={{ items }} placement="bottomRight">
          <Button icon={<PlusOutlined />} />
        </Dropdown>
      )}
      <DataMigrationModal isModal={isModal} setModal={setModal} />
    </div>
  );
};
